import { defineNuxtPlugin, useAsyncData } from "#app";
import { useDirectusItems } from "#imports";
import set from "lodash-es/set";
import get from "lodash-es/get";
import { COLLECTION, FIELDS } from "./constants.mjs";
const SEOAdvanceConfig = {};
const seoSettings = {};
export default defineNuxtPlugin(async (nuxtApp) => {
  console.log(`CDH Seo Loaded`);
  const itemServices = useDirectusItems();
  const { data: seoData } = await useAsyncData(() => itemServices.getItems({
    collection: COLLECTION.seo_advanced,
    params: {
      fields: [
        "collection",
        "enabled",
        "is_static",
        `translations.languages_code`,
        `translations.${FIELDS.seo_detail}.*`
      ]
    }
  }));
  for (const seo of seoData?.value || []) {
    const SEOByCollection = {};
    seo.translations?.map((item) => {
      const keyLang = item.languages_code?.toString()?.substring(0, 2);
      SEOByCollection[keyLang] = item?.[FIELDS.seo_detail];
    });
    SEOAdvanceConfig[seo.collection] = SEOByCollection;
  }
  const { data: settingCMS } = await useAsyncData(() => itemServices.getItems({
    collection: COLLECTION.seo_setting
  }));
  settingCMS?.value?.map(({ key, value }) => {
    const setting = {};
    const langCodes = Object.keys(value);
    langCodes?.map((langCode) => {
      const keyLang = langCode.toString().substring(0, 2);
      set(setting, keyLang, get(value, langCode));
    });
    set(seoSettings, key, setting);
  });
  nuxtApp.provide("SEOAdvanceConfig", SEOAdvanceConfig);
  nuxtApp.provide("SEOSettings", seoSettings);
});
